import Vue from 'vue'
import scheduleTemplateApi from '@/api/scheduleTemplate.api'

const state = {
  templates: {},
  scheduleTemplatesTotalCount: 0
}


const getters = {
  scheduleTemplates: (state) => {
    return Object.values(state.templates) || []
  },

  scheduleTemplateById: (state) => (id) => {
    return state.templates[id] || null
  }
}


const actions = {
  async loadScheduleTemplates ({ commit, rootState }, { skip, take, search, sortBy, sortDesc }) {
    const response = await scheduleTemplateApi.getScheduleTemplates(rootState.tenant.current, skip, take, search, sortBy, sortDesc)
    commit('SET_TEMPLATES', { templates: response.data, count: parseInt(response.headers['x-total-count']) })
  },

  async loadScheduleTemplateById ({ commit, rootState }, id) {
    const response = await scheduleTemplateApi.getScheduleTemplate(rootState.tenant.current, id)
    commit('SET_TEMPLATE', response.data)
    return response.data
  },

  async loadAndUpdateScheduleTemplate ({ commit, rootState }, entityData) {
    const response = await scheduleTemplateApi.getScheduleTemplate(rootState.tenant.current, entityData.entityId)
    commit('UPDATE_TEMPLATE', response.data)
    return response.data
  },

  async createScheduleTemplate ({ commit, rootState }, template) {
    state.scheduleTemplatesTotalCount = state.scheduleTemplatesTotalCount + 1
    const response = await scheduleTemplateApi.createScheduleTemplate(rootState.tenant.current, template)
    commit('CREATE_TEMPLATE', response.data)
  },

  async updateScheduleTemplate ({ commit, rootState }, template) {
    await scheduleTemplateApi.updateScheduleTemplate(rootState.tenant.current, template.id, template)
    commit('UPDATE_TEMPLATE', template)
  },

  async deleteScheduleTemplate ({ commit, rootState }, templateId) {
    state.scheduleTemplatesTotalCount = state.scheduleTemplatesTotalCount - 1
    await scheduleTemplateApi.deleteScheduleTemplate(rootState.tenant.current, templateId)
    commit('DELETE_TEMPLATE', templateId)
  }
}


const mutations = {
  SET_TEMPLATES (state, { templates, count }) {
    state.templates = {}
    for (const template of templates) {
      Vue.set(state.templates, template.id, template)
    }
    state.scheduleTemplatesTotalCount = count
  },

  SET_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  CREATE_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  UPDATE_TEMPLATE (state, template) {
    Vue.set(state.templates, template.id, template)
  },

  DELETE_TEMPLATE (state, id) {
    Vue.delete(state.templates, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
